import React from "react";

import { Segmented as AntSegmented, SegmentedProps as AntSegmentedProps } from "antd";

export type SegmentedProps<ValueType> = AntSegmentedProps<ValueType> & {
  dataTestId?: string;
};

export const Segmented = <ValueType,>({ className = "", dataTestId, ...props }: SegmentedProps<ValueType>) => (
  <AntSegmented<ValueType> className={`klim-segmented ${className}`} data-testid={dataTestId} {...props} />
);
